document.addEventListener('DOMContentLoaded', function () {
  // Get all dropdown items with the class ".active"
  var activeItems = document.querySelectorAll('.dropdown-item.active');
  // Loop through each active item and add the "active" class to the parent dropdown
  activeItems.forEach(function (item) {
    let parent = item.parentNode.closest('.nav-item');
    parent.querySelector('.nav-link').classList.add('active');
  });
});
